import React, { FC, MouseEvent, PropsWithChildren, useCallback, useEffect } from 'react'
import s from './ModalView.module.sass'
import { FloatingPortal } from '@floating-ui/react'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { useBlockScrollOverlay } from '@shared/lib/hooks/useBlockScrollOverlay'
import { IconButton } from '@shared/ui/Actions/IconButton'
import IconClose from '@icons/icon--x-big.svg'

type Props = {
  buttonClose?: boolean
  handleClose: () => void
  className?: string
}

export const ModalView: FC<PropsWithChildren<Props>> = ({ children, buttonClose = false, handleClose, className }) => {
  useBlockScrollOverlay()

  const checkTargetClick = (e: MouseEvent<HTMLDivElement>) => {
    e.currentTarget === e.target && handleClose()
  }

  const handleEscClose = useCallback((event) => {
    if (event.key === 'Escape') {
      handleClose()
    }
  }, [])

  // используем handleEscClose при нажатии на Esc для закрытия модального окна
  useEffect(() => {
    document.addEventListener('keydown', handleEscClose, false)
    return () => {
      document.removeEventListener('keydown', handleEscClose, false)
    }
  }, [handleEscClose])

  return (
    <ErrorBoundary>
      <FloatingPortal id='next-content'>
        {buttonClose && (
          <IconButton
            data-testid={'modal-button-close'}
            className={s['close-button']}
            icon={IconClose}
            mode={'white'}
            sizes={'XL'}
            onClick={handleClose}
          />
        )}
        <div className={`${s.modal}${className ? ` ${className}` : ''}`} onMouseDown={checkTargetClick}>
          {children}
        </div>
      </FloatingPortal>
    </ErrorBoundary>
  )
}
